export const personalInterests = {
    music: {
        favorite: "Dire Straits",
        artists: [
            "Pink Floyd",
            "Queen",
            "Talking Heads",
            "Led Zeppelin",
            "Police",
            "The Rolling Stones",
            "David Bowie",
            "Cat Empire",
            "Postmodern Jukebox",
        ]
    },
    food: {
        cuisine: "Italian",
        favorites: [
            "Carbonara",
            "Cacio e Pepe",
            "Pasta al Pomodoro",
            "Cannelloni",
            "Lasagna",
            "Tiramisu",
            "Pizza"
        ]
    },
    gaming: {
        platforms: ["PS5", "Nintendo Switch", "PC Gaming", "Retro Gaming"],
        retro: true,
        arcadeFavorites: [
            "Metal Slug",
            "Street Fighter III: 3rd Strike",
            "The King of Fighters '98",
            "Marvel vs Capcom 2"
        ]
    },
    crypto: {
        interests: ["Memecoin Analysis", "Smart Contracts", "DeFi"],
        tools: ["CoinGecko API", "Trading Algorithms", "Sentiment Analysis"],
        focus: "Short-term trend prediction and real-time market analysis"
    },
    homeProjects: {
        current: [
            "Smart Home Integration",
            "Home Office Setup",
            "Home Security System"
        ],
        planned: [
            "Google Camera Installation",
            "Living Room Renovation",
            "Conservatory Furnishing"
        ]
    },
    techPreferences: {
        editor: "Cursor and VS Code",
        packageManager: "Yarn",
        frameworks: ["Next.js", "React"],
        languages: ["TypeScript", "JavaScript", "Python"],
        testing: ["Jest", "React Testing Library", "Cypress"],
        styling: ["Tailwind CSS", "CSS Modules"],
        deployment: ["Vercel", "Digital Ocean", "AWS"],
        tools: ["Git", "GitHub", "VS Code", "Docker"]
    },
    workStyle: {
        preference: "Remote",
        workspace: "Personal Home Office",
        approach: "Efficient and direct problem-solving",
        focus: "Modern web technologies and blockchain development",
        beverages: {
            coffee: ["Espresso", "Americano with oat milk"],
            tea: ["Liquorice tea"]
        }
    },
    hobbies: [
        {
            "name": "Open Source",
            "type": "Technical",
            "details": "Trying to find time to contribute to open source projects as much as I can. Lately I have been focusing on building open source tools to prevent scams in the crypto space."
        },
        {
            "name": "Community Management",
            "type": "Social",
            "details": "Creating and managing online tech/art communities using Discord, Reddit, and Telegram integrations. I'm a big fan of Discord. I think that's clear by now."
        },
        {
            "name": "Discord Bot Development",
            "type": "Technical",
            "details": "Building custom Discord bots for communities. It's always fun to see people interacting with your bots."
        },
        {
            "name": "Digital Art",
            "type": "Creative",
            "details": "Creating digital artwork and NFTs using platforms like Procreate, and minting ERC1155 tokens"
        },
        {
            "name": "Memecoin Analytics",
            "type": "Crypto",
            "details": "Developing algorithms for predicting trends in memecoins and integrating real-time data analysis"
        },
        {
            "name": "Blockchain Development",
            "type": "Crypto",
            "details": "I constantly find myself building Smart contracts, Web3 applications and DApps for fun/small profits. The beauty of working with Crypto is that payments are absolutely trustless and decentralized. If the client is getting paid so am I, and there's no way around it."
        },
        {
            "name": "Browser Extensions",
            "type": "Crypto",
            "details": "Developing browser extensions for productivity, crypto wallets, and Web3 dApp interactions"
        },
        {
            "name": "Smart Home Automation",
            "type": "Technical",
            "details": "Setting up smart devices like Google cameras/Assistants and creating custom automations for convenience and security"
        },
        {
            "name": "Gadget Enthusiast",
            "type": "Recreational",
            "details": "I swear I spend way too much money random gadgets. I blame it all on my ADHD. My brain is like a toddler's when it comes down to that kind of stuff."
        },
        {
            "name": "AI-Powered Development",
            "type": "Technical",
            "details": "Leveraging AI tools to improve code quality, generate mock data, and streamline development workflows"
        },
        {
            "name": "Family Time",
            "type": "Personal",
            "details": "Spending quality time with my family."
        },
        {
            "name": "Manga and Anime",
            "type": "Recreational",
            "details": "Reading manga and watching anime, with a focus on shounen, sci-fi, and slice of life"
        },
        {
            "name": "Retro Technology",
            "type": "Recreational",
            "details": "Exploring arcade machines, gaming consoles, and other retro tech. I can't seem to be able to let go of the good old times."
        },
        {
            "name": "Gaming",
            "type": "Recreational",
            "details": "From time to time I enjoy playing videogames, especially RPGs, action-adventures and co-op games with my friends from Italy."
        }
    ]
}; 